"use strict";

require("core-js/modules/es.symbol.description.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allIconNames = exports.PetSureIconSets = exports.PetSureIconList = exports.FlatPetSureIconSet = void 0;
require("core-js/modules/es.array.reduce.js");
var _petsureIcons = _interopRequireDefault(require("../../../../icons/petsure-icons.json"));
var _PetSureIcons$iconSet;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const allIconNames = exports.allIconNames = [];
const PetSureIconSets = exports.PetSureIconSets = (_PetSureIcons$iconSet = _petsureIcons.default.iconSets) === null || _PetSureIcons$iconSet === void 0 ? void 0 : _PetSureIcons$iconSet.map(iconSet => {
  const thisSet = {};
  const {
    selection,
    metadata,
    height
  } = iconSet;
  thisSet.label = metadata.name;
  thisSet.icons = iconSet.icons.reduce((acc, icon) => {
    const {
      id,
      paths,
      width
    } = icon;
    const {
      name
    } = selection.find(item => item.id === id);
    allIconNames.push(name);
    acc[name] = {
      paths,
      width,
      height
    };
    return acc;
  }, {});
  return thisSet;
});
const FlatPetSureIconSet = exports.FlatPetSureIconSet = PetSureIconSets === null || PetSureIconSets === void 0 ? void 0 : PetSureIconSets.reduce((acc, iconSet) => {
  return _objectSpread(_objectSpread({}, acc), iconSet.icons);
}, {});
const PetSureIconList = exports.PetSureIconList = allIconNames;